import * as React from "react";
import { ICellRendererParams } from "ag-grid-community";

class RankRenderer extends React.Component<ICellRendererParams, {}> {
    refresh(params: any) {
        return true;
    }

    render() {
        return (
            <span>{this.props.rowIndex + 1}</span>
        );
    }
}

export default RankRenderer;